var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showLoader
    ? _c("client-board-dynamic-loader")
    : _c(
        "div",
        { staticClass: "h-100 position-relative vertical-flex-fit" },
        [
          _c(
            "div",
            {
              directives: [{ name: "dragscroll", rawName: "v-dragscroll" }],
              staticClass:
                "row no-gutters drag-wrapper scroll-control-wrapper mt-0",
            },
            _vm._l(_vm.orderedStatuses, function (status) {
              return _c(
                "status-column",
                _vm._b(
                  { key: status.id },
                  "status-column",
                  Object.assign({}, status),
                  false
                )
              )
            }),
            1
          ),
          _vm._v(" "),
          _c("add-activity-note-modal"),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }